'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var CheckboxIcon = require('../../02.molecules/CheckboxIcon/CheckboxIcon.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-panel-checkbox-icon',
    cnCol = "".concat(CLASSNAME, "__col"),
    cnCheckbox = "".concat(CLASSNAME, "__checkbox");
/**
 * 
 */

var PanelCheckboxIcon = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(PanelCheckboxIcon, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(PanelCheckboxIcon);

  function PanelCheckboxIcon() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, PanelCheckboxIcon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onChange", function (value, add) {
      var onChange = _this.props.onChange;

      if (add) {
        _this.values.push(value);
      } else {
        var index = _this.values.indexOf(value);

        if (!isNaN(index)) {
          _this.values[index] = undefined;
          _this.values = _this.values.filter(function (a) {
            return !isNaN(a);
          });
        }
      }

      onChange(_this.values);
    });

    var selected = _this.props.selected;
    _this.values = _rollupPluginBabelHelpers.toConsumableArray(selected);
    return _this;
  }

  _rollupPluginBabelHelpers.createClass(PanelCheckboxIcon, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var selected = this.props.selected;
      this.values = _rollupPluginBabelHelpers.toConsumableArray(selected);
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var _this$props = this.props,
          items = _this$props.items,
          breakpoint = _this$props.breakpoint,
          percentage = 100 / items.length;
      var lg = 12 / items.length;

      if (lg % 1 !== 0 && (breakpoint === 'lg' || breakpoint === 'xl')) {
        return {
          style: {
            maxWidth: "".concat(percentage, "%"),
            flexBasis: "".concat(percentage, "%")
          }
        };
      }

      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          items = _this$props2.items,
          selected = _this$props2.selected,
          defaultChecked = _this$props2.defaultChecked,
          name = _this$props2.name,
          type = _this$props2.type,
          _this$getStyle = this.getStyle(),
          style = _this$getStyle.style;

      return /*#__PURE__*/React__default.createElement("div", {
        className: CLASSNAME
      }, items.map(function (item) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: cnCol,
          style: style,
          key: item.value
        }, /*#__PURE__*/React__default.createElement(CheckboxIcon, {
          className: cnCheckbox,
          name: name,
          type: type,
          selected: selected.length ? selected.indexOf(item.value) > -1 : undefined,
          defaultChecked: defaultChecked ? defaultChecked.indexOf(item.value) > -1 : undefined,
          title: item.title,
          iconId: item.iconId,
          onChange: _this2.onChange,
          value: item.value
        }));
      }));
    }
  }]);

  return PanelCheckboxIcon;
}(React__default.Component);
PanelCheckboxIcon.propTypes = {
  /** Breakpoint for grid display */
  breakpoint: PropTypes.string,

  /** Array of items that should be checked by default */
  defaultChecked: PropTypes.array,

  /** Array of items containing e.g. title and iconId */
  items: PropTypes.array,

  /** Name of the panel */
  name: PropTypes.string,

  /** Callback function */
  onChange: PropTypes.func,

  /** True if selected */
  selected: PropTypes.array,

  /** Type of checkboxes */
  type: PropTypes.oneOf(['checkbox', 'radio'])
};
PanelCheckboxIcon.defaultProps = {
  items: [],
  onChange: function onChange() {
    return void 0;
  },
  selected: [],
  type: 'checkbox'
};

module.exports = PanelCheckboxIcon;
